// extracted by mini-css-extract-plugin
module.exports = {"Layout":"layout_Layout__29fAE"};